// extracted by mini-css-extract-plugin
export default {"container":"contact_container__2-F5X","logo":"contact_logo__lS26k"};